import $ from 'jquery';
window.$ = window.jQuery = $;
import Modal from 'bootstrap/js/dist/modal';
import Tooltip from 'bootstrap/js/dist/tooltip';
import WOW from 'wow.js';
import VenoBox from 'venobox';
// import IMask from 'imask/esm/imask'
import Swiper from 'swiper';
import { Autoplay, FreeMode } from 'swiper/modules';
Swiper.use([Autoplay, FreeMode]);

$(function(){
    "use strict";

    function updateBackgrounds() {
        $('[data-img]').each(function() {
            let img = this.getAttribute('data-img');
            let imgMobile = this.getAttribute('data-img-mobile');
            let isMobile = window.innerWidth <= 768;
            let bg = isMobile && imgMobile ? imgMobile : img;

            $(this).css({
                background: 'url(' + bg + ') no-repeat center',
                backgroundSize: 'cover'
            });
        });
    }

    $(document).ready(updateBackgrounds);
    $(window).on('resize', updateBackgrounds);

    $('.header-menu a[href="#"]').on("click", function (e) {
        e.preventDefault();
    });

    $( document ).ready(function() {
        setTimeout(()=>{
            $('.preloader').fadeOut();
        }, 250)
    });

    $('.top-btn').on('click',function(){
        $('html').animate({
            scrollTop: 0
        },1000);
    });

    $(window).on('scroll',function(){
        var $scroll = $(this).scrollTop();

        if($scroll > 300){
            $('.top-btn').addClass('show');
        }else{
            $('.top-btn').removeClass('show');
        }
    });

    function menuSticky (){
        var $scroll = $(window).scrollTop();
        if($scroll > 120){
            $('.menubar').addClass('sticky');
        }else{
            $('.menubar').removeClass('sticky');
        }
    }
    menuSticky ()
    $(window).on('scroll',function(){
        menuSticky ()
    });

    var wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: false,
        live: true,
        scrollContainer: null
    });
    wow.init();

    new VenoBox({
        selector: '.video_player',
    });

    $(document).ready(function () {
        const $container = $('#desktop-video-container');
        let videoAppended = false;

        function handleVideoDisplay() {
            const isDesktop = $(window).width() >= 768;

            if (isDesktop && !videoAppended && $container.length) {
                const video = document.createElement('video');
                video.autoplay = true;
                video.loop = true;
                video.muted = true;
                video.playsInline = true;
                video.preload = 'metadata';
                video.className = 'position-absolute top-0 start-0 object-fit-cover w-100 h-100 z-n1';
                video.id = 'dynamic-desktop-video';

                const source = document.createElement('source');
                source.src = '/video/slider.mp4';
                source.type = 'video/mp4';
                video.appendChild(source);

                $container.append(video);
                videoAppended = true;

                video.play().catch(function (error) {
                    console.warn('Autoplay blocked:', error);
                });
            } else if (!isDesktop && videoAppended) {
                $('#dynamic-desktop-video').remove();
                videoAppended = false;
            }
        }

        // Початковий виклик
        handleVideoDisplay();

        // Обробка зміни розміру
        $(window).on('resize', function () {
            handleVideoDisplay();
        });
    });

    // // Підключення маски IMask
    // if ($('.js-mask-phone').length > 0) {
    //     Promise.all([
    //         import('imask/esm/imask'),
    //         import('imask/esm/masked/pattern')
    //     ]).then(([{ default: IMask }]) => {
    //         const phone = $('.js-mask-phone').get(0);
    //         const maskOptions = {
    //             mask: "+{38} (000) 000 00 00"
    //         };
    //         IMask(phone, maskOptions);
    //     });
    // }

    if ($('.brand-swiper').length > 0) {
        const swiper = new Swiper('.brand-swiper', {
            slidesPerView: 'auto',
            spaceBetween: 10,
            loop: true,
            speed: 5000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
            },
            freeMode: {
                enabled: true,
                momentum: false,
                momentumBounce: false,
                minimumVelocity: 0.05,
                sticky: false,
            },
            grabCursor: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
        });

        const container = document.querySelector('.brand-swiper');
        container.addEventListener('mouseenter', () => swiper.autoplay.stop());
        container.addEventListener('mouseleave', () => swiper.autoplay.start());
    }

    $('#burger-toggle').on('click', function () {
        $('#mobile-sidebar').addClass('active');
        $('#mobile-overlay').removeClass('d-none');
        $('body').addClass('no-scroll');
    });

    $('#close-sidebar, #mobile-overlay, #mobile-sidebar a').on('click', function () {
        $('#mobile-sidebar').removeClass('active');
        $('#mobile-overlay').addClass('d-none');
        $('body').removeClass('no-scroll');
    });

    $(function() {
        $('[data-bs-toggle="tooltip"]').each(function() {
            new Tooltip(this);
        });
    });
});
